import { html } from "lit";
var icon_bold_default = () => html`
  <svg stroke-fill viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <g stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
        <path d="M4.5 17.5H11a4.5 4.5 0 1 0 0-9h.5a3 3 0 1 0 0-6h-7" />
        <path d="M6.5 2.5v15" />
        <path d="M11 8.5H6.5" />
      </g>
    </g>
  </svg>
`;
export {
  icon_bold_default as default
};
//# sourceMappingURL=icon-bold.js.map
